module.exports = __webpack_public_path__ + "static/media/delete-icon.0df34c06.webp";